import { Icon } from '@ontruck/orc';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { actions as orderActions } from 'state/order';
import PropTypes from 'prop-types';
import cx from 'classnames';

const EditStopBtn = ({ className }) => {
  const { t } = useTranslation('OrderStop');
  const dispatch = useDispatch();

  const onClick = () => {
    dispatch(orderActions.navigateToForm());
  };

  return (
    <button
      data-testid="edit-stop-btn"
      className={cx(className, 'edit-stop-btn')}
      type="button"
      onClick={onClick}
    >
      <span>
        <Icon glyph="edit" size="16px" color="primary500" />
        {` ${t('button_label')}`}
      </span>
    </button>
  );
};

EditStopBtn.propTypes = {
  className: PropTypes.string,
};

export default EditStopBtn;
